export const formatTitle = <T>(list: T[], title: string) => ((list || []).length > 1 ? `${title}s` : title);

const maxSizeTitle = 80;
export const formatTitleHeader = (title: string): string => {
  if (title?.length > maxSizeTitle) {
    return `${title.substring(0, maxSizeTitle - 3)}...`;
  }
  return title;
};
